const PHONE = "0604026840";
const PHONE_DISPLAY = "06 04 02 68 40";
const WHATSAPP_URL = `https://wa.me/33604026840?text=Bonjour%2C%20j%27ai%20besoin%20d%27un%20serrurier%20en%20urgence`;

export default function HeroSection() {
  return (
    <section
      id="accueil"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20locksmith%20working%20at%20night%20on%20a%20door%20lock%20in%20urban%20Paris%20suburb%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20cinematic%20style%2C%20high%20contrast%20black%20and%20yellow%20tones%2C%20professional%20tools%2C%20security%20expert%2C%20French%20apartment%20building%20entrance%2C%20photorealistic&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Serrurier urgence Créteil Val-de-Marne"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        {/* Diagonal stripes overlay */}
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, #FFB100 0px, #FFB100 4px, transparent 4px, transparent 40px)",
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-16 flex flex-col items-center text-center">
        {/* Badge urgence */}
        <div
          className="inline-flex items-center gap-2 bg-[#FFB100] text-black text-xs font-black px-4 py-1.5 rounded-full mb-6 uppercase tracking-widest"
          style={{ animation: "badge-pulse 2s infinite" }}
        >
          <span className="w-2 h-2 bg-black rounded-full inline-block"></span>
          Urgence 24h/24 — 7j/7
          <style>{`
            @keyframes badge-pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.85; }
            }
          `}</style>
        </div>

        {/* Main title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-4 uppercase tracking-tight">
          Serrurier d&apos;Urgence
          <br />
          <span className="text-[#FFB100]">à Créteil</span>
          <br />
          <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
            &amp; Val-de-Marne
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-white/80 text-base md:text-lg font-light mb-8 max-w-xl">
          Intervention en <strong className="text-[#FFB100] font-bold">20 minutes</strong> — Ouverture de porte • Serrure connectée • Ouverture &amp; reprogrammation voiture
        </p>

        {/* Service cards */}
        <div className="flex flex-col sm:flex-row gap-3 mb-10 w-full max-w-2xl">
          {[
            { icon: "ri-door-open-line", label: "Ouverture de porte", bg: "bg-white text-black", href: undefined },
            { icon: "ri-lock-2-line", label: "Serrure connectée", bg: "bg-[#FFB100] text-black", href: undefined },
            { icon: "ri-car-line", label: "Ouverture & reprogrammation voiture", bg: "bg-white text-black", href: "https://ouverture-voiture.fr/" },
            { icon: "ri-window-line", label: "Réparation de volets", bg: "bg-[#FFB100] text-black", href: "https://voleturgence.fr/" },
          ].map((card) => {
            const inner = (
              <>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${card.icon} text-xl`}></i>
                </div>
                <span>{card.label}</span>
              </>
            );
            return card.href ? (
              <a
                key={card.label}
                href={card.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className={`flex-1 flex items-center gap-3 ${card.bg} rounded-2xl px-4 py-3 font-bold text-sm cursor-pointer hover:opacity-90 transition-opacity`}
              >
                {inner}
              </a>
            ) : (
              <div
                key={card.label}
                className={`flex-1 flex items-center gap-3 ${card.bg} rounded-2xl px-4 py-3 font-bold text-sm`}
              >
                {inner}
              </div>
            );
          })}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-lg">
          <a
            href={`tel:${PHONE}`}
            className="flex-1 flex items-center justify-center gap-2 bg-[#FFB100] text-black font-black text-sm md:text-base py-3 md:py-4 rounded-full hover:bg-yellow-400 transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-phone-fill text-base md:text-xl"></i>
            Appeler le {PHONE_DISPLAY}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-white/10 border-2 border-white text-white font-bold text-sm md:text-base py-3 md:py-4 rounded-full hover:bg-white hover:text-black transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base md:text-xl"></i>
            WhatsApp
          </a>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-4 mt-8 text-white/60 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-shield-check-line text-[#FFB100]"></i>
            Devis gratuit
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-[#FFB100]"></i>
            Intervention 20 min
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-[#FFB100]"></i>
            4.9/5 sur Google
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line text-[#FFB100]"></i>
            Tout le Val-de-Marne
          </span>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/40 animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
